const normalizeDegree = (deg: number) => ((deg % 360) + 360) % 360;

const angleIsBetween = (deg: number, minDegree: number, maxDegree: number) => {
    const norDeg = normalizeDegree(deg);
    const norMin = normalizeDegree(minDegree);
    const norMax = normalizeDegree(maxDegree);

    if (norMin > norMax) {
        // something like -20° -- 20° before normalization, 340° -- 20° after normalization
        return norDeg > norMin || norDeg <= norMax;
    } else {
        return norDeg > norMin && norDeg <= norMax;
    }
};

export default angleIsBetween;
